import { useIntl } from 'react-intl';
import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import { Box } from '@packages/shared/src/components/Box/Box';
import { Button } from '@packages/shared/src/components/Button/Button';
import { Link } from '@packages/shared/src/components/Link/Link';
import { generalFormMessages } from './messages';
import { basicContainer } from './styles';

export type FormFooterAreaProps = {
  /** Indicates that the form is valid and the button should be enabled */
  isValid: boolean;
  submitButton: {
    /** Button text when the button is enabled */
    enabled: string;
    /** Button text when the button is disabled */
    disabled: string;
  };
};

/**
 * Renders the bottom area of the form with a button and a link back to storefront
 */
export const FormFooterArea = ({ isValid, submitButton }: FormFooterAreaProps) => {
  const intl = useIntl();
  const { isMobile } = useDeviceType();

  return (
    <Box sx={{ ...basicContainer, textAlign: 'center', paddingTop: 2 }}>
      <Button
        disabled={!isValid}
        size="large"
        fullWidth={isMobile}
        color="primary"
        type={isValid ? 'submit' : 'button'}
      >
        {isValid ? submitButton.enabled : submitButton.disabled}
      </Button>

      <Box sx={{ ...basicContainer, color: 'text.darkTransparent' }}>
        <Link href="/" color="inherit" sx={{ paddingTop: 2.5, display: 'block' }}>
          {intl.formatMessage(generalFormMessages.backToStorefront)}
        </Link>
        <Box sx={{ paddingTop: 4, typography: 'body3' }}>
          {intl.formatMessage(generalFormMessages.mandatory)}
        </Box>
      </Box>
    </Box>
  );
};
